import { Result, IUser } from '@/classes'
import { fetchAPI } from '@/utils/useAPI'
import { INotification } from '@/classes/Notification'

export const readNotificationAPI = async (params: {
	type: 'read' | 'delete' | 'delete-all'
	notifications?: string[]
}) => {
	const response: Result<{ notifications: INotification[] }> = await fetchAPI('user/notifications', params, { method: 'POST' })

	if (!response.ok) return response

	return {
		ok: true,
		data: response.data
	}
}
